var _path, _ellipse, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifiLow = function SvgWifiLow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 31 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A246",
    fillRule: "evenodd",
    d: "M22.937 18.04c-4.05-4.05-10.572-4.094-14.568-.098l1.709 1.709c3.03-3.03 8.023-3.03 11.15.098z",
    clipRule: "evenodd"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.684,
    cy: 22.538,
    fill: "#F7A246",
    rx: 1.922,
    ry: 1.948,
    transform: "rotate(-45 15.684 22.538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7A246",
    strokeWidth: 2.417,
    d: "M1.302 11.177c4.531-5.135 17.219-10.573 28.396 0",
    opacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F7A246",
    strokeWidth: 2.417,
    d: "M5.23 15.104c4.833-5.437 14.5-6.344 20.843 0",
    opacity: 0.25
  })));
};
export { SvgWifiLow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMjkiIHZpZXdCb3g9IjAgMCAzMSAyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi45Mzc0IDE4LjAzOThDMTguODg3NCAxMy45ODk4IDEyLjM2NDkgMTMuOTQ2IDguMzY4OSAxNy45NDJMMTAuMDc3NyAxOS42NTA5QzEzLjEwODQgMTYuNjIwMiAxOC4xMDA2IDE2LjYyMDcgMjEuMjI4NiAxOS43NDg2TDIyLjkzNzQgMTguMDM5OFoiIGZpbGw9IiNGN0EyNDYiLz4KPGVsbGlwc2UgY3g9IjE1LjY4MzgiIGN5PSIyMi41Mzc5IiByeD0iMS45MjI0NSIgcnk9IjEuOTQ4NDMiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxNS42ODM4IDIyLjUzNzkpIiBmaWxsPSIjRjdBMjQ2Ii8+CjxwYXRoIG9wYWNpdHk9IjAuMjUiIGQ9Ik0xLjMwMjEyIDExLjE3NzFDNS44MzMzNyA2LjA0MTY5IDE4LjUyMDkgMC42MDQxOTMgMjkuNjk4IDExLjE3NzEiIHN0cm9rZT0iI0Y3QTI0NiIgc3Ryb2tlLXdpZHRoPSIyLjQxNjY3Ii8+CjxwYXRoIG9wYWNpdHk9IjAuMjUiIGQ9Ik01LjIyOTEzIDE1LjEwNDJDMTAuMDYyNSA5LjY2NjY3IDE5LjcyOTEgOC43NjA0MiAyNi4wNzI5IDE1LjEwNDIiIHN0cm9rZT0iI0Y3QTI0NiIgc3Ryb2tlLXdpZHRoPSIyLjQxNjY3Ii8+Cjwvc3ZnPgo=";